// DB module format
export interface ApplicationControlModule {
  general: ApplicationControlGeneral;
  startRules: ApplicationControlStartRuleItem[];
}

export interface ApplicationControlGeneral {
  enable: boolean;
  reportOnly: boolean;
}

export interface ApplicationControlStartRuleItem {
  name: string;
  active: boolean;
  action: ApplicationControlRuleAction;
  targets: ApplicationControlRuleTargets;
  includeSubprocesses: boolean;
  exclusions?: ApplicationControlRuleTargets;
}

export interface ApplicationControlStartRuleItemFormValue extends ApplicationControlStartRuleItem {
  defaultPositionInGrid: number;
}

export interface ApplicationControlRuleTargets {
  type: ApplicationControlRuleTargetsType;
  appInventory?: ApplicationControlRuleTargetsAppInventory[];
  processes?: ApplicationControlRuleTargetsProcesses[];
}

export interface ApplicationControlRuleTargetsProcesses {
  type: ApplicationControlTargetProcessType;
  match: string;
  description: string;
  context: ApplicationControlTargetContext[] | number;
}

export interface ApplicationControlRuleTargetsAppInventory {
  id: string;
  type: number;
  name: string;
}

export interface ApplicationInventoryItemResponse {
  _id: string;
  type: number;
  name: string;
}

export enum ApplicationControlRuleAction {
  ALLOW = 1,
  BLOCK = 2,
}

export enum ApplicationControlRuleTargetsType {
  SPECIFIC_PROCESSES = 1,
  APPLICATIONS_INVENTORY = 2,
}

export enum ApplicationControlTargetProcessType {
  PATH = 1,
  HASH = 2,
  CERTIFICATE = 3,
}

export enum ApplicationControlTargetContext {
  LOCAL = 1,
  CDROM = 2,
  REMOVABLE = 3,
  NETWORK = 4,
}
